<template>
  <div class="card-sensor-value">
    <span class="time">{{ time }}</span>
    <span class="name">{{ name }}</span>
    <span class="value">{{ displayValue }}</span>
  </div>
</template>

<script>
export default {
  name: 'AppCardSensorValue',
  props: {
    /**
     * 測定時刻
     */
    time: {
      type: String,
      default: '',
    },
    /**
     * 表示名称
     */
    name: {
      type: String,
      default: '',
    },
    /**
     * 表示値
     */
    value: {
      type: [String, Number],
      default: null,
    },
    /**
     * 単位
     */
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * 表示用値
     * @type {String}
     */
    displayValue: function () {
      if (this.value !== 0 && !this.value) return '-'
      return this.unit ? `${this.value} ${this.unit}` : this.value
    },
  },
}
</script>

<style lang="scss" scoped>
.card-sensor-value {
  width: auto;
  height: 100%;
  background-color: #f8f8f8;
  border: 1px solid #cfd5db;
  border-radius: 0;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
  font-size: $font-size-small;
  text-align: center;
  line-height: 1.1;
}

.time {
  color: #959595;
}

.name {
  vertical-align: middle;
}

.value {
  font-weight: $font-weight-bold;
}
</style>
